import API from "../../api/Api.service";

// GET /leaderboard — ranked list ordered by `filter`; rank = page offset + index + 1.
// page_size is capped at 100 by the backend.
const getLeaderboard = async ({
  level = "global",
  page = 1,
  pageSize = 100,
  filter = "score",
} = {}) => {
  const res = await API.get("/leaderboard", {
    params: {
      page,
      page_size: pageSize,
      filter,
      level,
    },
  });

  return res.data;
};

const LeaderboardService = {
  getLeaderboard,
};

export default LeaderboardService;
